module.exports = __webpack_public_path__ + "img/oct-blue.d9853925.svg";